var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"information"},[_c('div',{staticClass:"articles"},_vm._l((_vm.articles),function(article){return _c('Article',{key:article.id,attrs:{"title":article.title,"text":article.text,"status":article.status}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }